module.exports = __webpack_public_path__ + "img/Fram489.36789e85.png";